import { Client } from "../../../client";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import { proccessErrorMessage } from "../../../Helper/proccessErrorMessage";
import {
  API_GET_PRODUCT_INTEREST,
  API_GET_REALESTATE_INTEREST,
} from "../../../config/api";

export const getInvestmentBookings = createAsyncThunk(
  "InvestmentBookings/GET",
  async ({ id, cb, failed, type }, { rejectWithValue }) => {
    try {
      const { data } = await Client({
        method: "GET",
        path:
          type == "property"
            ? API_GET_REALESTATE_INTEREST + id
            : API_GET_PRODUCT_INTEREST + id,
      });

      cb(data);
      return data?.data;
    } catch (error) {
      failed();
      const msg = proccessErrorMessage(error);
      toast.error(msg);
      return rejectWithValue(error.message);
    }
  }
);
